const CUSTOMILY_UPSELL_ID = '_customily-upsell-id';
const CUSTOMILY_DATA_UPSELL_ID = 'data-upsell-id';
const CUSTOMILY_DATA_ID = 'data-id';

function getCart() {
    return new Promise((resolve, reject) => {
        jQuery.getJSON('/cart.js')
            .done((cart) => {
                resolve(cart);
            })
            .fail(reject);
    });
}

function updateCartItems(items) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js?customily_upsell',
            data: {
                updates: items
            },
            dataType: 'json'
        }).done((result) => {
            resolve(result);
        }).fail((error) => {
            console.error(error);
            reject(error);
        });
    });
}

function getItemByKey(key) {
    return shopifyCartData.items.find(
        item => item.key && item.key === key
    );
}

function getAddonsFromUpsellId(upsellId) {
    return shopifyCartData.items.filter(
        item => item.properties && item.properties[CUSTOMILY_UPSELL_ID] === upsellId
    );
}

async function changeQuantity(item, quantity, upsellId = '') {
    const itemsToUpdate = {};
    let items = [];
    if (upsellId) {
        items = getAddonsFromUpsellId(upsellId);
        for (const item of items) {
            itemsToUpdate[`${item.key}`] = quantity;
        }
    }

    itemsToUpdate[`${item.key}`] = quantity;

    try {
        await updateCartItems(itemsToUpdate);
        console.log(`Customily Shopify: cart items updated: ${JSON.stringify(itemsToUpdate)}`);
        window.location.reload();
    } catch (e) {
        console.error(e);
    }
}

jQuery(document).on('click', '.customily-item-remove', async function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    const $el = jQuery(this);
    const itemKey = $el.attr(CUSTOMILY_DATA_ID);

    if (itemKey) {
        console.log(`Customily Shopify: removing item ${itemKey}`);
        const item = getItemByKey(itemKey);
        const $parent = $el.parents('customily-cart-items');
        $parent.css('opacity', '0.2');
        const upsellId = $el.attr(CUSTOMILY_DATA_UPSELL_ID);
        await changeQuantity(item, 0, upsellId);
        $parent.css('opacity', '1');
    }
});

jQuery(document).on('change', '.customily-qty-input', async function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    const $el = jQuery(this);
    const itemKey = $el.attr(CUSTOMILY_DATA_ID);

    if (itemKey) {
        console.log(`Customily Shopify: changing item ${itemKey}`);
        const item = getItemByKey(itemKey);
        const $parent = $el.parents('customily-cart-items');
        $parent.css('opacity', '0.2');
        const upsellId = $el.attr(CUSTOMILY_DATA_UPSELL_ID);
        const quantity = Number($el.val());
        await changeQuantity(item, quantity, upsellId);
        $parent.css('opacity', '1');
    }
});

let shopifyCartData;
getCart().then(function (data) {
    shopifyCartData = data;
});

console.log('Customily Shopify: cart handler');